var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.isEdit ? "编辑集市" : "添加集市",
          backUrl: "/market/list",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTab, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c("div", { staticClass: "form-tips" }, [
            _c("i", { staticClass: "el-icon-info" }),
            _c("span", [
              _vm._v("请按照步骤填写集市信息，带 "),
              _c("span", { staticClass: "required-mark" }, [_vm._v("*")]),
              _vm._v(" 的字段为必填项"),
            ]),
          ]),
          _c(
            "el-form",
            {
              key: _vm.currentTab,
              ref: "marketForm",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "1",
                      expression: "currentTab === '1'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "merId" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", [_vm._v("关联商户：")]),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: {
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                placeholder: "请选择商户",
                                "remote-method": _vm.remoteSearchMerchant,
                                loading: _vm.merchantLoading,
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.form.merId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "merId", $$v)
                                },
                                expression: "form.merId",
                              },
                            },
                            _vm._l(_vm.merchantOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "1",
                      expression: "currentTab === '1'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketName" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市名称：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketName,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: "请输入集市名称",
                              disabled: _vm.isDisabled,
                              maxlength: "50",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.marketName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "marketName", $$v)
                              },
                              expression: "form.marketName",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketType" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市类型：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketType,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isDisabled },
                              model: {
                                value: _vm.form.marketType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "marketType", $$v)
                                },
                                expression: "form.marketType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("长期"),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("短期"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "environmentType" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("经营环境：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.environmentType,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isDisabled },
                              model: {
                                value: _vm.form.environmentType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "environmentType", $$v)
                                },
                                expression: "form.environmentType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("室内"),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("室外"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "siteType" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市属性：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.siteType,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请选择集市属性",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.form.siteType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "siteType", $$v)
                                },
                                expression: "form.siteType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "商圈", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "社区", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "公园", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "场馆", value: 4 },
                              }),
                              _c("el-option", {
                                attrs: { label: "景区", value: 5 },
                              }),
                              _c("el-option", {
                                attrs: { label: "乐园", value: 6 },
                              }),
                              _c("el-option", {
                                attrs: { label: "展会", value: 7 },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "area" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市面积：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.area,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              min: 0,
                              precision: 2,
                              placeholder: "请输入集市面积",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.area,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "area", $$v)
                              },
                              expression: "form.area",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("单位：平方米(㎡)"),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "capacity" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("容纳摊位数：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.capacity,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input-number", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              min: 0,
                              placeholder: "请输入容纳摊位数",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.capacity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "capacity", $$v)
                              },
                              expression: "form.capacity",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "regionCode" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("省市区：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.regionCode,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-cascader", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              options: _vm.regionOptions,
                              props: _vm.regionProps,
                              disabled: _vm.isDisabled || _vm.regionLoading,
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择省 / 市 / 区",
                            },
                            on: { change: _vm.handleRegionChange },
                            model: {
                              value: _vm.form.regionCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "regionCode", $$v)
                              },
                              expression: "form.regionCode",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "detail" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("详细地址：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.detail,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "400px" },
                              attrs: { placeholder: "请在地图中选择地址" },
                              on: {
                                click: function ($event) {
                                  !_vm.isDisabled && _vm.openMapDialog()
                                },
                              },
                              model: {
                                value: _vm.form.detail,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "detail", $$v)
                                },
                                expression: "form.detail",
                              },
                            },
                            [
                              !_vm.isDisabled
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "append",
                                        icon: "el-icon-location",
                                      },
                                      on: { click: _vm.openMapDialog },
                                      slot: "append",
                                    },
                                    [_vm._v(" 选择 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "2",
                      expression: "currentTab === '2'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketAreaList" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("摊位设置：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketAreaList,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "stall-settings-container" },
                            [
                              _vm._l(
                                _vm.visibleAreas,
                                function (area, areaIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: areaIndex,
                                      staticClass: "area-item",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "area-header" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "area-title" },
                                            [
                                              _vm._v(
                                                "区域 " + _vm._s(areaIndex + 1)
                                              ),
                                            ]
                                          ),
                                          !_vm.isDisabled
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeArea(
                                                        areaIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 删除区域 ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 16 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "marketAreaList." +
                                                      areaIndex +
                                                      ".areaName",
                                                    rules: [
                                                      {
                                                        required: true,
                                                        message:
                                                          "请输入区域名称",
                                                        trigger: "blur",
                                                      },
                                                    ],
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "区域名称",
                                                      disabled: _vm.isDisabled,
                                                    },
                                                    model: {
                                                      value: area.areaName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          area,
                                                          "areaName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "area.areaName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "marketAreaList." +
                                                      areaIndex +
                                                      ".areaRemark",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "区域描述",
                                                      disabled: _vm.isDisabled,
                                                    },
                                                    model: {
                                                      value: area.areaRemark,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          area,
                                                          "areaRemark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "area.areaRemark",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "location-list" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "location-header" },
                                            [
                                              _c("span", [_vm._v("位置列表")]),
                                              !_vm.isDisabled
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addLocation(
                                                            areaIndex
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 添加位置 ")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-table",
                                            {
                                              attrs: {
                                                data: area.marketStallList.filter(
                                                  function (stall) {
                                                    return !stall.isDel
                                                  }
                                                ),
                                                border: "",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "位置编号",
                                                  width: "80",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.$index + 1
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "位置名称",
                                                  "min-width": "120",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "位置名称",
                                                              disabled:
                                                                _vm.isDisabled,
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .stallName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "stallName",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.stallName",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "位置描述",
                                                  "min-width": "150",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "位置描述",
                                                              disabled:
                                                                _vm.isDisabled,
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .stallRemark,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "stallRemark",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.stallRemark",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "100",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          !_vm.isDisabled
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticStyle: {
                                                                    padding:
                                                                      "4px 8px",
                                                                    "font-size":
                                                                      "12px",
                                                                  },
                                                                  attrs: {
                                                                    type: "danger",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeLocation(
                                                                          areaIndex,
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " 删除 "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "div",
                                { staticClass: "add-area-section" },
                                [
                                  !_vm.isDisabled
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.addArea },
                                        },
                                        [_vm._v(" 添加区域 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketLayoutImgs" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("摊位分布图：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketLayoutImgs,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "upload-images-container" },
                            [
                              _c("div", { staticClass: "upload-tips" }, [
                                _c("span", [_vm._v("最多支持上传9张图片")]),
                                _c("span", { staticClass: "image-count" }, [
                                  _vm._v(
                                    _vm._s(_vm.form.marketLayoutImgs.length) +
                                      "/9"
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "image-list" },
                                [
                                  _vm._l(
                                    _vm.form.marketLayoutImgs,
                                    function (img, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "image-item",
                                        },
                                        [
                                          _c("img", { attrs: { src: img } }),
                                          !_vm.isDisabled
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-error btndel",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeLayoutImage(
                                                      index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm.form.marketLayoutImgs.length < 9 &&
                                  !_vm.isDisabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "upload-item",
                                          on: { click: _vm.uploadLayoutImages },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-plus",
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "upload-text" },
                                            [_vm._v("上传图片")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "3",
                      expression: "currentTab === '3'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "customerType" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("客户类型：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.customerType,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: "如：年轻白领、亲子家庭",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.customerType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "customerType", $$v)
                              },
                              expression: "form.customerType",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "dailyVisitorCount" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("日均客流量：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      _vm.fieldTooltips.dailyVisitorCount,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: "如：60000-80000人/天",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.dailyVisitorCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dailyVisitorCount", $$v)
                              },
                              expression: "form.dailyVisitorCount",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "facilities", required: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市设施：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.facilities,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("br"),
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { disabled: _vm.isDisabled },
                              model: {
                                value: _vm.form.facilities,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "facilities", $$v)
                                },
                                expression: "form.facilities",
                              },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "水" } },
                                        [_vm._v("水")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "电" } },
                                        [_vm._v("电")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "桌子" } },
                                        [_vm._v("桌子")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "椅子" } },
                                        [_vm._v("椅子")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "空调" } },
                                        [_vm._v("空调")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "wifi" } },
                                        [_vm._v("Wi-Fi")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "帐篷" } },
                                        [_vm._v("帐篷")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "停车场" } },
                                        [_vm._v("停车场")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "桌布" } },
                                        [_vm._v("桌布")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "储物间" } },
                                        [_vm._v("储物间")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 4 } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "遮阳伞" } },
                                        [_vm._v("遮阳伞")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 13 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketImgs", required: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市图片：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketImgs,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "upload-images-container" },
                            [
                              _c("div", { staticClass: "upload-tips" }, [
                                _c("span", [_vm._v("最多支持上传20张图片")]),
                                _c("span", { staticClass: "image-count" }, [
                                  _vm._v(
                                    _vm._s(_vm.form.marketImgs.length) + "/20"
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "image-list" },
                                [
                                  _vm._l(
                                    _vm.form.marketImgs,
                                    function (img, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "image-item",
                                        },
                                        [
                                          _c("img", { attrs: { src: img } }),
                                          !_vm.isDisabled
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-error btndel",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeMarketImage(
                                                      index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm.form.marketImgs.length < 20 &&
                                  !_vm.isDisabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "upload-item",
                                          on: { click: _vm.uploadMarketImages },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-plus",
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "upload-text" },
                                            [_vm._v("上传图片")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketInfo", required: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市描述：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketInfo,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "600px" },
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              placeholder: "请输入集市描述",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.marketInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "marketInfo", $$v)
                              },
                              expression: "form.marketInfo",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactPerson", required: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市联系人：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.contactPerson,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入联系人姓名",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.contactPerson,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "contactPerson", $$v)
                              },
                              expression: "form.contactPerson",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "该信息方便主办方管理,不会在任何地方展示给其他人"
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactPhone", required: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市联系电话：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.contactPhone,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入联系电话",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.contactPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "contactPhone", $$v)
                              },
                              expression: "form.contactPhone",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "集市主用于沟通的电话号码，用户报名成功后可查看"
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "marketOwnerPhoto" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("集市主微信二维码：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.marketOwnerPhoto,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "upload-images-container single" },
                            [
                              _c("div", { staticClass: "image-list" }, [
                                _vm.form.marketOwnerPhoto
                                  ? _c(
                                      "div",
                                      { staticClass: "image-item" },
                                      [
                                        _c("el-image", {
                                          staticClass: "image-preview",
                                          attrs: {
                                            src: _vm.form.marketOwnerPhoto,
                                            "preview-src-list": [
                                              _vm.form.marketOwnerPhoto,
                                            ],
                                            fit: "cover",
                                          },
                                        }),
                                        !_vm.isDisabled
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-error btndel",
                                              on: {
                                                click:
                                                  _vm.removeMarketOwnerPhoto,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.form.marketOwnerPhoto && !_vm.isDisabled
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "upload-item",
                                        on: {
                                          click: _vm.uploadMarketOwnerPhoto,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "upload-text" },
                                          [_vm._v("上传二维码")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm.form.marketOwnerPhoto && !_vm.isDisabled
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "reupload-btn",
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        size: "mini",
                                      },
                                      on: { click: _vm.uploadMarketOwnerPhoto },
                                    },
                                    [_vm._v(" 重新上传 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "上传集市主用于沟通的微信二维码，用户报名成功后可查看"
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "remark" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [_vm._v("备注信息：")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.fieldTooltips.remark,
                                    placement: "top",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question field-tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "600px" },
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              placeholder: "请输入备注信息",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "该信息方便主办方管理,不会在任何地方展示给其他人"
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.isDisabled
                ? _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "btn-container" },
                          [
                            _vm.currentTab !== "1"
                              ? _c(
                                  "el-button",
                                  { on: { click: _vm.handleSubmitUp } },
                                  [_vm._v("上一步")]
                                )
                              : _vm._e(),
                            _vm.currentTab !== "3"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      loading: _vm.saveStepLoading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSaveAndNext(
                                          "marketForm"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 保存并填写下一步 ")]
                                )
                              : _vm._e(),
                            _vm.currentTab === "3"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "success",
                                      loading: _vm.submitLoading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSubmit("marketForm")
                                      },
                                    },
                                  },
                                  [_vm._v(" 保存 ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              { on: { click: _vm.handleCancel } },
                              [_vm._v("取消")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "map-dialog",
          attrs: {
            title: "地图选择位置",
            visible: _vm.mapDialogVisible,
            width: "1200px",
            "before-close": _vm.handleMapDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.mapDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "map-dialog-content" }, [
            _c(
              "div",
              { staticClass: "search-section" },
              [
                _c(
                  "div",
                  { staticClass: "search-scope-row" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "small" },
                        on: { change: _vm.handleSearchScopeChange },
                        model: {
                          value: _vm.searchScope,
                          callback: function ($$v) {
                            _vm.searchScope = $$v
                          },
                          expression: "searchScope",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "current" } }, [
                          _vm._v("当前城市"),
                        ]),
                        _c("el-radio-button", { attrs: { label: "city" } }, [
                          _vm._v("指定城市"),
                        ]),
                        _c(
                          "el-radio-button",
                          { attrs: { label: "nationwide" } },
                          [_vm._v("全国")]
                        ),
                      ],
                      1
                    ),
                    _vm.searchScope === "city"
                      ? _c("el-cascader", {
                          staticClass: "search-city-picker",
                          attrs: {
                            options: _vm.regionOptions,
                            props: _vm.searchRegionProps,
                            disabled: _vm.regionLoading,
                            clearable: "",
                            filterable: "",
                            size: "small",
                            placeholder: "选择目标城市",
                          },
                          on: { change: _vm.handleSearchCityChange },
                          model: {
                            value: _vm.searchRegionCode,
                            callback: function ($$v) {
                              _vm.searchRegionCode = $$v
                            },
                            expression: "searchRegionCode",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              placeholder: "请输入地点名称搜索",
                              "remote-method": _vm.searchLocation,
                              loading: _vm.searchLoading,
                              "no-data-text": _vm.searchNoDataText,
                              size: "large",
                            },
                            on: {
                              change: _vm.handleSearchResultChange,
                              "visible-change": _vm.handleSelectVisibleChange,
                            },
                            model: {
                              value: _vm.selectedSearchResult,
                              callback: function ($$v) {
                                _vm.selectedSearchResult = $$v
                              },
                              expression: "selectedSearchResult",
                            },
                          },
                          [
                            _vm._l(_vm.searchResults, function (result, index) {
                              return _c(
                                "el-option",
                                {
                                  key: index,
                                  attrs: {
                                    label: result.name,
                                    value: result,
                                    disabled: false,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "search-option-item" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "option-name" },
                                        [_vm._v(_vm._s(result.name))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "option-address" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              result.city
                                                ? result.city + " · "
                                                : ""
                                            ) + _vm._s(result.address)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _vm.hasMoreResults
                              ? _c(
                                  "el-option",
                                  {
                                    key: "load-more",
                                    staticClass: "load-more-option",
                                    attrs: { value: null, disabled: true },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "load-more-section" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "load-more-btn",
                                            attrs: {
                                              type: "text",
                                              loading: _vm.loadingMore,
                                            },
                                            on: {
                                              click: _vm.loadMoreResults,
                                              mousedown: function ($event) {
                                                $event.stopPropagation()
                                              },
                                              mouseup: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.loadingMore
                                                    ? "加载中..."
                                                    : "加载更多"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticClass: "search-buttons" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.handleMapDialogClose },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled:
                                  !_vm.selectedAddress ||
                                  _vm.reverseGeocodeLoading,
                                size: "mini",
                              },
                              on: { click: _vm.confirmLocation },
                            },
                            [_vm._v(" 确认选择 ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "map-section" }, [
              _c(
                "div",
                {
                  staticClass: "map-container",
                  attrs: { id: "tencentMapContainer" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "map-controls",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "location-btn",
                          attrs: { title: "定位到当前位置" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleLocationClick($event)
                            },
                            mousedown: function ($event) {
                              $event.stopPropagation()
                            },
                            mouseup: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-location" })]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm.selectedAddress
              ? _c("div", { staticClass: "selection-result" }, [
                  _c("div", { staticClass: "result-card" }, [
                    _c("div", { staticClass: "result-header" }, [
                      _c("span", { staticClass: "result-title" }, [
                        _c("i", { staticClass: "el-icon-location-outline" }),
                        _vm._v(" 已选择位置 "),
                      ]),
                    ]),
                    _c("div", { staticClass: "result-content" }, [
                      _c("div", { staticClass: "main-address" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectedLocationName || _vm.selectedAddress
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "coordinate-info" }, [
                        _c("span", { staticClass: "coords" }, [
                          _vm._v(
                            "坐标：" +
                              _vm._s(_vm.selectedLng) +
                              ", " +
                              _vm._s(_vm.selectedLat)
                          ),
                        ]),
                        _vm.selectedAddressDetail &&
                        _vm.selectedAddressDetail.business
                          ? _c("span", { staticClass: "business" }, [
                              _vm._v(
                                " | 商圈：" +
                                  _vm._s(_vm.selectedAddressDetail.business) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.selectedAddressDetail &&
                        _vm.selectedAddressDetail.addressComponent &&
                        _vm.selectedAddressDetail.addressComponent.city
                          ? _c("span", { staticClass: "city" }, [
                              _vm._v(
                                " | 城市：" +
                                  _vm._s(
                                    _vm.selectedAddressDetail.addressComponent
                                      .city
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.selectedAddressDetail &&
                        _vm.selectedAddressDetail.addressComponent &&
                        _vm.selectedAddressDetail.addressComponent.district
                          ? _c("span", { staticClass: "district" }, [
                              _vm._v(
                                " | 区县：" +
                                  _vm._s(
                                    _vm.selectedAddressDetail.addressComponent
                                      .district
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }